import { Injectable } from '@angular/core';
import { AxiosError } from 'axios';

const SQL_FK_CONSTRAINT_MATCHER =
  /The DELETE statement conflicted with the REFERENCE constraint "(.*)"\. The conflict occurred in database ".*", table "dbo\.(.*)", column '(.*)'./;

@Injectable({
  providedIn: 'root'
})
export class ErrorTextService {
  constructor() {}

  /**
   * Expand this method as needed
   * @returns A hopefully easy-to-read error message with significant whitespace.
   */
  getFriendlyMessage(error: Error) {
    // Priority at the bottom, closer to the return statement.
    // Lower statements will overwrite the statements above them.
    let reason = error.message;

    let axiosError = error as AxiosError;
    if (axiosError.isAxiosError) {
      if (axiosError.response) {
        let err = axiosError.response.data;
        // err is the Response Body from the API.
        reason = err.message;
        console.error('Axios Request Error:', err);
        // is the error nested deeper?
        if (
          err.message.indexOf('See the inner exception for details.') != -1 &&
          err.detail
        ) {
          reason = err.detail;
          // Is it a Foreign Key Reference Error?
          let match = (err.detail as string).match(SQL_FK_CONSTRAINT_MATCHER);
          if (match) {
            let [_fullSentence, _constraint, table, column] = match;
            reason = `This record is in use.\n\t- Table:${table}, Column:${column}`;
          }
        }
      } else {
        reason = axiosError.message;
      }
    }

    return reason;
  }
}
